import { createSelector } from '@reduxjs/toolkit'
import { getCollectionOrEmptyObject } from '@opallabs/lambda'
import { getAvatars } from '../../getters/entities/avatars'

export const selectAvatars = createSelector([getAvatars], (avatars) =>
  getCollectionOrEmptyObject(avatars)
)
